import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Popup from "../components/PopUP";
import axios from "axios";
import APIURL from '../components/Constant'


const CreateNewPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [popupMessage, setPopupMessage] = useState("");


  useEffect(() => {
    const email = Cookies.get('verify_email') || navigate('/forget');
    setEmail(email);
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Password:", password);
    console.log("Confirm Password:", confirmPassword);
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }
    setError("");

    const body = {
      email : email,
      new_password: password,
      confirm_password: confirmPassword
    }

    try{
      const response  = await axios.post(APIURL+'/user-service/auth/reset-password', body)
      console.log("Response:", response.data.detail);
      setPopupMessage(response.data.detail)
      Cookies.remove('verify_email');
      setTimeout(() => {
       navigate('/login');
      }, 3000);
    }
    catch(error){
      setError(error.response && error.response.data ? error.response.data.detail || "Something wrong please try again." : "Something wrong please try again.");
      console.log("Error:", error);
    }
  };

  return (
    <div className="credential_main_wrapper">
       <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <div className="credential_content_outer">
        <div className="credential_content_wrapper">
          <div className="credential_logo">
            <img src="assets/images/logo-white.svg" alt="Logo" />
          </div>
        </div>
      </div>

      <div className="credential_form_wrapper">
        <div className="credential_form_card">
          <div className="credential_content_info">
            <h1>Create New Password</h1>
            <p className="mb-0 credential_sub_heading">
              Please remember your new password.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form_field_wrapper">
              <div className="form_field mb-3">
                <label htmlFor="createPassword">New Password</label>
                <div className="input_field">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    id="createPassword"
                    placeholder="Enter your new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={`fa-regular ${
                        showPassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                      id="eyeCreate"
                    ></i>
                  </span>
                </div>
              </div>

              <div className="form_field">
                <label htmlFor="reEnterPassword">Confirm Password</label>
                <div className="input_field">
                  <input
                    type={showConfirm ? "text" : "password"}
                    className="form-control"
                    name="confirmPassword"
                    id="reEnterPassword"
                    placeholder="Enter your confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowConfirm(!showConfirm)}
                  >
                    <i
                      className={`fa-regular ${
                        showConfirm ? "fa-eye" : "fa-eye-slash"
                      }`}
                      id="eyeReenter"
                    ></i>
                  </span>
                </div>
                {error && <span className="error">{error}</span>}
              </div>
            </div>

            <div className="form-btn-blk">
              <button
                type="submit"
                className="form-btn w-100 fw-bold text-white text-capitalize"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateNewPassword;
